import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
export default function FloatingWhatsAppButton() {
  return <a className="whatsapp-link" href="https://wa.me/919949360406?text=Hello%20Tejesh%20Profine%2C%20I%20would%20like%20to%20discuss%20windows%20and%20doors." target="_blank" rel="noopener noreferrer" aria-label="Chat with Tejesh Profine on WhatsApp" title="Chat on WhatsApp"><FaWhatsapp aria-hidden="true" focusable="false" /></a>;
}
